import { render, staticRenderFns } from "./attendees.vue?vue&type=template&id=4b6965db&"
import script from "./attendees.vue?vue&type=script&lang=js&"
export * from "./attendees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports